/**
 * Software Secure Decode Robustness.
 *
 * @group DRM
 *
 * @beta
 */
export const SW_SECURE_DECODE = 'SW_SECURE_DECODE';
